import { Line, mixins } from 'vue-chartjs'
import Chart from 'chart.js'
import { formatNumber } from '../utils'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  computed: {
    ...mapState('dashboardServices', ['riskEnterpriseData', 'riskEnterpriseLoading'])
  },
  data: () => ({
    options: {
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontSize: 8,
          fontColor: 'rgba(0, 0, 0, 0.87)',
          fontStyle: '500'
        }
      },
      tooltips: {
        backgroundColor: '#221f2e',
        callbacks: {
          label: function (tooltipItem, data) {
            let label = data.datasets[tooltipItem.datasetIndex].label || ''
            if (label) {
              label += ': $'
            }
            label += formatNumber(Math.round(tooltipItem.yLabel))
            return label
          },
          title: function (data) {
            return moment(data[0].xLabel, 'YYYY-MM-DD').format('MMMM-YY')
          }
        }
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'rgba(0, 0, 0, 0.05)',
              borderDash: [8, 4],
              zeroLineColor: 'rgba(0, 0, 0, 0.1)',
              zeroLineWidth: 1
            },
            ticks: {
              fontSize: 12,
              fontColor: 'rgba(0, 0, 0, 0.87)',
              fontStyle: '500',
              callback: function (value) {
                return moment(value, 'YYYY-MM-DD').format('MMM-YY')
              }
            },
            barPercentage: 1,
            stacked: true
          }
        ],
        yAxes: [
          {
            gridLines: {
              color: 'rgba(0, 0, 0, 0.05)',
              borderDash: [8, 4],
              zeroLineColor: 'rgba(0, 0, 0, 0.1)',

              zeroLineWidth: 1
            },
            scaleLabel: {
              display: false,
              fontSize: 10,
              fontColor: '#212338',
              fontStyle: '500',
              padding: { top: 0, bottom: 10 }
            },
            ticks: {
              fontSize: 12,
              beginAtZero: true,
              fontColor: '#212338',
              fontStyle: '700',
              callback: function (value) {
                if (String(value).length === 6) {
                  return '$' + Math.floor(value / 1000) + 'K'
                } else if (String(value).length > 7 && String(value).length < 10) {
                  // If is million
                  return '$' + Math.floor(value / 1000000) + 'M'
                } else if (String(value).length > 9) {
                  // If is million
                  return '$' + Math.floor(value / 1000000000) + 'B'
                }
                return '$' + formatNumber(value)
              }
            }
          }
        ]
      }
    }
  }),
  mounted () {
    const draw = Chart.controllers.line.prototype.draw
    Chart.controllers.line = Chart.controllers.line.extend({
      draw: function () {
        draw.apply(this, arguments)
        const ctx = this.chart.chart.ctx
        const _stroke = ctx.stroke
        ctx.stroke = function () {
          ctx.save()
          ctx.shadowColor = 'rgba(0, 0, 0, 0.11)'
          ctx.shadowBlur = 5
          ctx.shadowOffsetX = 5
          ctx.shadowOffsetY = 12
          _stroke.apply(this, arguments)
          ctx.restore()
        }
      }
    })
    this.options.onClick = this.handleClick
    this.renderChart(this.chartData, this.options)
  },
  methods: {
    handleClick (_, event) {
      let prevIndex
      const itemIndex = event?.[2]?._index
      if (prevIndex === itemIndex) return
      if (itemIndex || itemIndex === 0) {
        this.$emit('click', itemIndex)
        prevIndex = itemIndex
      }
    }
  }
}
